function handleErrorCode( {errorCode, errorMsg, idx } ) {
  
  const container = document.querySelector('div[data-enroll="error-container"]'),
        pagesTemplate = container.querySelector('template[data-enroll="errorTemplate"]').content.querySelector('div[data-enroll="errorsPage"]'),
        modalTemplate = container.querySelector('template[data-enroll="errorTemplate"]').content.querySelector('div[data-enroll="errorsModal"]'),
        modalErrorCodes = [ 2, 5, 7, ],
        findError = modalErrorCodes.includes( errorCode ),
        viewer = $(container).find("*[data-enroll='error-container-viewer']");   

  if( !findError ) {

    let showErrorPage = pagesTemplate.querySelector(`div[data-error-id='${errorMsg}']`)?.cloneNode(true);
    !showErrorPage?showErrorPage=pagesTemplate.querySelector(`div[data-error-id='default']`)?.cloneNode(true):null;
    viewer.empty().append(showErrorPage);
    
  } else {    

    let showErrorModal = modalTemplate.querySelector(`div[data-error-id='${errorMsg}']`)?.cloneNode(true);
    !showErrorModal?showErrorModal=pagesTemplate.querySelector(`div[data-error-id='default']`)?.cloneNode(true):null;
    showErrorModal.querySelector('#myModal').style.display = 'block';
    container.append(showErrorModal);

    let closeBtn = showErrorModal.querySelector('.btn-primary');
    closeBtn.addEventListener('click', () => showErrorModal.querySelector('#myModal').remove());

  }

} 